import React from 'react';
import Search from '../../../Search/Search';

import classes from './DisplayOptions.module.scss';

export const positions = {
  left: 'left',
  right: 'right'
};

export const bottomSpaces = {
  next: 'next',
  space: 'space'
};

const DisplayOptions = ({
  classContent,
  open,
  options,
  position = positions.left,
  bottomSpace = bottomSpaces.next,
  toogleOpenHandler,
  selected,
  onChange,
  value,
  onBlur,
  reference,
  selectOptions
}) => {
  const positionClass = `list-${position}`;
  const bottomSpaceClass = `list-${bottomSpace}`;
  const listClasses = [classes.list, classes[positionClass], classes[bottomSpaceClass]];
  if (classContent) {
    listClasses.push(classContent);
  }

  const selectOption = handler => {
    handler();
    toogleOpenHandler();
  };

  return (
    <>
      {open && (
        <div
          tabIndex={0}
          className={listClasses.join(' ')}
          {...(selectOptions.length < 5 && { ref: reference, onBlur: onBlur })}
          //</>ref={selectOptions.length < 5 ? reference : ''}
        >
          {open && selectOptions.length > 5 && (
            <Search placeholder='Buscar' onValueChange={onChange} onBlur={onBlur} reference={reference} />
          )}
          <div className={classes['list-items']}>
            {options.map(({ value, label, handler }, idx) => (
              <span
                key={idx}
                id={idx}
                name={value}
                className={`list-items ${selected === value ? 'selected semibold-16' : 'medium-16'}`}
                onClick={() => selectOption(handler)}>
                {label}
              </span>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default DisplayOptions;
